(function () {
    'use strict';

    angular
        .module('highSchoolVisit')
        .config(highSchoolVisitRoute);

    highSchoolVisitRoute.$inject = ['$stateProvider'];

    /* @ngInject */
    function highSchoolVisitRoute($stateProvider) {
        $stateProvider
            .state('root.highSchoolVisit', {
                abstract: true,
                url: '/highschoolvisit',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                }
            })
            .state('root.highSchoolVisit.students', {
                abstract: true,
                url: '/students',
                resolve: {
                    // 
                }
            })
            .state ('root.highSchoolVisit.students.registrationsData', {
                url: '/registrations-data',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/highschoolvisit/students/registrationsdata/list.html',
                        controller: 'HighSchoolVisitStudentsRegistrationsDataController',
                        controllerAs: 'highSchoolVisitStudentsRegistrationsData'
                    }
                },
                resolve: {
                    physicalFairs: function (HighSchoolVisitService) {
                        return HighSchoolVisitService.getExpos().then(response => response.data);
                    },
                    virtualFairs: function (VirtualFairService) {
                        return VirtualFairService.getAllHighSchool().then(response => response.data);
                    },
                }
            })
            .state('root.highSchoolVisit.exhibitors', {
                abstract: true,
                url: '/exhibitors',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                }
            })
            .state ('root.highSchoolVisit.exhibitors.accommodations', {
                url: '/accommodations',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/highschoolvisit/exhibitors/accommodations/reportFilter.html',
                        controller: 'HighSchoolVisitExhibitorAccommodationController',
                        controllerAs: 'highSchoolVisitExhibitorAccommodation'
                    }
                }
            })
            .state ('root.highSchoolVisit.exhibitors.transportations', {
                url: '/transportations',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/highschoolvisit/exhibitors/transportations/reportFilter.html',
                        controller: 'HighSchoolVisitExhibitorTransportationController',
                        controllerAs: 'highSchoolVisitExhibitorTransportation'
                    }
                }
            })
            .state ('root.highSchoolVisit.exhibitors.representatives', {
                url: '/representatives',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/highschoolvisit/exhibitors/representatives/reportFilter.html',
                        controller: 'HighSchoolVisitExhibitorRepresentativeController',
                        controllerAs: 'highSchoolVisitExhibitorRepresentative'
                    }
                }
            })
    }
})();